
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Punetomumbaicabs() {



    const cardData =
    {
        keyword: 'Pune to Mumbai Cabs',
        heading: 'Meghana Cab : Pune to Mumbai Cabs',
        headingDescription: 'Meghana Cab offers Pune to Mumbai Cabs, delivering a reliable, comfortable, and timely travel experience between two of Maharashtra’s busiest cities. Whether you are heading to Mumbai for work, leisure, or an airport drop, our fleet of clean, AC cabs with professional drivers ensures a smooth and safe journey. Choose from a range of vehicle options, enjoy competitive pricing, on-time service, and 24/7 support. Book your Pune to Mumbai Cab with Meghana Cab and travel stress-free with trusted service and comfort.',


        top: 'Top Places to Visit in Mumbai with Meghana Cab',

"topPlaces": [
  {
    "title": "Gateway of India",
    "description": "An iconic monument overlooking the Arabian Sea, the Gateway of India was built in 1924 to commemorate the visit of King George V. It is one of Mumbai’s most photographed landmarks and serves as the starting point for ferry rides to Elephanta Caves and Alibaug."
  },
  {
    "title": "Marine Drive",
    "description": "Also known as the Queen’s Necklace, this 3.6 km boulevard stretches along the Arabian Sea. It is popular for evening walks, sunset views, and the glittering skyline. The curved road lined with palm trees offers one of the best urban sea views in India."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CST)",
    "description": "A UNESCO World Heritage Site, this historic railway station combines Victorian Gothic architecture with Indian influences. It is both a major transport hub and an architectural marvel with detailed carvings, stained glass, and a bustling atmosphere."
  },
  {
    "title": "Elephanta Caves",
    "description": "Located on Elephanta Island, a short ferry ride from Mumbai, these ancient rock-cut caves date back to the 5th–8th centuries. The caves feature sculptures and carvings dedicated to Lord Shiva, including the famous three-headed Maheshmurti."
  },
  {
    "title": "Colaba Causeway",
    "description": "A vibrant street market known for its eclectic shops, street food, art galleries, and colonial architecture. It's a great place for souvenir shopping and is surrounded by landmark cafes like Leopold and Café Mondegar."
  },
  {
    "title": "Siddhivinayak Temple",
    "description": "One of Mumbai’s most revered temples, dedicated to Lord Ganesha. Devotees from across the country visit for blessings, especially on Tuesdays. The temple's architecture, gold-plated dome, and peaceful ambiance make it spiritually significant."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Built on an islet off the coast, this Indo-Islamic shrine houses the tomb of Sufi saint Pir Haji Ali Shah Bukhari. It is accessible via a narrow causeway during low tide and offers a unique blend of spirituality and sea views."
  },
  {
    "title": "Chor Bazaar",
    "description": "One of the oldest flea markets in India, Chor Bazaar is famous for antiques, vintage goods, Bollywood posters, and secondhand treasures. It offers a fascinating look into Mumbai’s historic trade culture."
  },
  {
    "title": "Juhu Beach",
    "description": "A popular beach in the suburbs of Mumbai, known for its street food stalls, leisure crowd, and celebrity sightings. Visitors enjoy pav bhaji, ice gola, and walks along the shoreline, especially during the evenings."
  },
  {
    "title": "Sanjay Gandhi National Park & Kanheri Caves",
    "description": "Located in Borivali, this massive national park offers a green escape with hiking trails, lion and tiger safaris, and the historic Kanheri Buddhist caves carved into basalt rock. It’s a blend of nature, history, and recreation."
  }
],

"services": [
    {
        "name": "Pune to Pandharpur Temple Cab",
        "description": "Travel comfortably from Pune to Pandharpur Temple with Meghana Cab’s reliable and safe taxi service. Ideal for pilgrimage and spiritual journeys, our cabs offer a peaceful and hassle-free ride."
    },
    {
        "name": "Book Taxi Pune to Pandharpur",
        "description": "Easily book a taxi from Pune to Pandharpur online with Meghana Cab. Enjoy quick booking, professional drivers, and timely pickups for a smooth travel experience to the holy city."
    },
    {
        "name": "One Way Cab to Pandharpur from Pune",
        "description": "Opt for an affordable and convenient one-way cab service from Pune to Pandharpur. Perfect for solo travelers and pilgrims who prefer flexible travel plans without return trip obligations."
    },
    {
        "name": "Round Trip Pune to Pandharpur Taxi",
        "description": "Plan your round trip from Pune to Pandharpur with Meghana Cab. Our round trip taxi service ensures comfort, safety, and on-time service for your entire pilgrimage journey."
    },
    {
        "name": "AC Cab Pune to Pandharpur Trip",
        "description": "Travel in comfort with air-conditioned taxis from Pune to Pandharpur. Meghana Cab offers well-maintained AC vehicles to make your pilgrimage trip pleasant even in hot weather."
    },
    {
        "name": "Affordable Cabs to Pandharpur",
        "description": "Get the best budget-friendly cab options from Pune to Pandharpur without compromising on service quality. Meghana Cab provides competitive fares and transparent pricing."
    },
    {
        "name": "Pilgrimage Cab Pune to Pandharpur",
        "description": "Make your religious trip special with Meghana Cab’s dedicated pilgrimage taxi service. Our drivers are experienced in routes to Pandharpur and offer a respectful and calm travel environment."
    },
    {
        "name": "Private Car Hire to Pandharpur from Pune",
        "description": "Hire a private car for your trip from Pune to Pandharpur with Meghana Cab. Enjoy exclusive use of the vehicle, personalized schedules, and privacy throughout your spiritual journey."
    },
    {
        "name": "Pune to Pandharpur Driver Cab",
        "description": "Travel safely with professional chauffeur-driven taxis from Pune to Pandharpur. Our skilled drivers ensure a smooth, comfortable ride and punctual service."
    },
    {
        "name": "Sedan & SUV Pune to Pandharpur",
        "description": "Choose from a wide range of sedans and SUVs for your Pune to Pandharpur trip based on your group size and comfort preferences. Meghana Cab ensures quality vehicles and excellent service."
    },
    {
        "name": "Book Outstation Cab for Pandharpur",
        "description": "Conveniently book outstation taxis for your Pandharpur trip from Pune. Meghana Cab offers reliable vehicles suitable for long-distance travel with all necessary amenities."
    },
    {
        "name": "Pune to Pandharpur Road Travel",
        "description": "Experience smooth and scenic road travel from Pune to Pandharpur with Meghana Cab. Our taxis follow the safest and fastest routes ensuring timely arrivals and enjoyable journeys."
    },
    {
        "name": "Fast Cab Pune to Pandharpur",
        "description": "Need a quick and efficient taxi to Pandharpur from Pune? Meghana Cab provides fast booking and timely cab arrivals to ensure you reach your destination on schedule."
    },
    {
        "name": "Religious Tour Cab Pune to Pandharpur",
        "description": "Enhance your religious tour experience with Meghana Cab’s specialized cab services. Our vehicles are comfortable and well-equipped for pilgrim groups traveling to Pandharpur."
    },
    {
        "name": "24/7 Taxi to Pandharpur from Pune",
        "description": "Avail 24/7 taxi service from Pune to Pandharpur with Meghana Cab. Whether it’s an early morning or late night journey, our taxis are available around the clock to serve your needs."
    }
],

"tableData": [
    ["Pune to Pandharpur Temple Cab", "Book Taxi Pune to Pandharpur"],
    ["One Way Cab to Pandharpur from Pune", "Round Trip Pune to Pandharpur Taxi"],
    ["AC Cab Pune to Pandharpur Trip", "Affordable Cabs to Pandharpur"],
    ["Pilgrimage Cab Pune to Pandharpur", "Private Car Hire to Pandharpur from Pune"],
    ["Pune to Pandharpur Driver Cab", "Sedan & SUV Pune to Pandharpur"],
    ["Book Outstation Cab for Pandharpur", "Pune to Pandharpur Road Travel"],
    ["Fast Cab Pune to Pandharpur", "Religious Tour Cab Pune to Pandharpur"],
    ["24/7 Taxi to Pandharpur from Pune", ""],
    ["", ""]
],











"whychoose": [
    {
        "WhyChooseheading": "Reliable Pune to Mumbai Cabs",
        "WhyChoosedescription": "Meghana Cab offers dependable Pune to Mumbai cabs that ensure a safe and comfortable journey between the two cities, perfect for business or leisure travel."
    },
    {
        "WhyChooseheading": "Wide Range of Vehicle Options",
        "WhyChoosedescription": "Choose from hatchbacks, sedans, SUVs, and luxury cars for your Pune to Mumbai trip, catering to solo travelers, families, and groups."
    },
    {
        "WhyChooseheading": "Experienced Drivers Familiar with Pune-Mumbai Routes",
        "WhyChoosedescription": "Our professional drivers know the Mumbai-Pune Expressway and city routes well, ensuring timely and smooth rides."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Enjoy competitive and upfront pricing with no hidden charges on all Pune to Mumbai cab bookings."
    },
    {
        "WhyChooseheading": "Clean and Comfortable Vehicles",
        "WhyChoosedescription": "Travel in well-maintained, sanitized, and air-conditioned cabs to make your Pune to Mumbai journey pleasant."
    },
    {
        "WhyChooseheading": "24/7 Availability for Your Convenience",
        "WhyChoosedescription": "Book your Pune to Mumbai cab any time—day or night—with Meghana Cab’s round-the-clock service."
    },
    {
        "WhyChooseheading": "Easy Booking via App, Website, or Phone",
        "WhyChoosedescription": "Quickly reserve your Pune to Mumbai cab using our user-friendly app, website, or by calling customer support."
    },
    {
        "WhyChooseheading": "Flexible One-Way and Round-Trip Options",
        "WhyChoosedescription": "Whether you need a one-way ride or a round trip between Pune and Mumbai, Meghana Cab offers flexible booking options tailored to your needs."
    }
]



































    }

const faqData = [
    {
        question: "How can I book a cab from Pune to Mumbai with Meghana Cab?",
        answer: "You can book a Pune to Mumbai cab by calling Meghana Cab at +91 9075462128 or through our website for quick and easy booking."
    },
    {
        question: "What types of vehicles are available for Pune to Mumbai trips?",
        answer: "We provide sedans, SUVs, and tempo travellers to suit your travel group and comfort preferences."
    },
    {
        question: "Are Meghana Cab drivers experienced for Pune to Mumbai routes?",
        answer: "Yes, our drivers are knowledgeable about the best routes between Pune and Mumbai for a safe and timely journey."
    },
    {
        question: "Can I book a one-way or round-trip cab from Pune to Mumbai?",
        answer: "Yes, both one-way and round-trip services are available based on your travel needs."
    },
    {
        question: "What is included in the Pune to Mumbai cab fare?",
        answer: "The fare includes driver charges, fuel, and vehicle maintenance. Additional costs like tolls and parking may apply."
    },
    {
        question: "Is Meghana Cab available 24/7 for Pune to Mumbai bookings?",
        answer: "Yes, we operate round-the-clock to assist you with your Pune to Mumbai cab service."
    },
    {
        question: "Can I book a cab for a large group from Pune to Mumbai?",
        answer: "Yes, we offer tempo travellers and SUVs for larger groups."
    },
    {
        question: "Are the vehicles sanitized and safe for travel?",
        answer: "All our vehicles are cleaned and sanitized regularly to ensure your safety."
    },
    {
        question: "What payment methods are accepted for Pune to Mumbai cab bookings?",
        answer: "We accept UPI, credit/debit cards, net banking, and cash."
    },
    {
        question: "How can I contact Meghana Cab for Pune to Mumbai cab service?",
        answer: "Call Meghana Cab at +91 9075462128 to book or inquire about Pune to Mumbai cabs."
    }
];

const testimonialsData = [
    {
        name: 'Mr. Ajay Deshmukh',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Meghana Cab provided a comfortable and timely Pune to Mumbai cab service. The driver was courteous and the ride smooth.”',
    },
    {
        name: 'Ms. Nisha Patil',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Excellent Pune to Mumbai cab service from Meghana Cab. Highly recommend for reliability and comfort.”',
    },
];




























































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];







const cabServiceSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "@id": "https://www.meghanacabs.com/pune-to-mumbai-cabs#service",
  "serviceType": "Pune to Mumbai Cabs",
  "provider": {
    "@type": "LocalBusiness",
    "name": "Meghana Cabs",
    "url": "https://www.meghanacabs.com/"
  },
  "areaServed": ["Pune","Mumbai","Navi Mumbai","Thane","Lonavala","Panvel","Maharashtra","CSMIA T1","CSMIA T2"],
  "description": "Book reliable Pune to Mumbai cabs—one-way or round trip—with clean AC Sedan & SUV, fixed pricing options, and 24x7 support. Professional, verified drivers.",
  "offers": {
    "@type": "AggregateOffer",
    "priceCurrency": "INR",
    "lowPrice": "1999",
    "highPrice": "6499",
    "offerCount": "14",
    "availability": "https://schema.org/InStock",
    "url": "https://www.meghanacabs.com/pune-to-mumbai-cabs"
  },
  "aggregateRating": { "@type": "AggregateRating", "ratingValue": "4.9", "ratingCount": 6894 }
};

const localBusinessSchema = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "@id": "https://www.meghanacabs.com/#biz",
  "name": "Meghana Cabs",
  "url": "https://www.meghanacabs.com/",
  "image": "https://www.meghanacabs.com/assets/images/pune-to-mumbai-cabs.jpg",
  "priceRange": "₹₹",
  "address": { "@type": "PostalAddress", "addressLocality": "Pune", "addressRegion": "MH", "addressCountry": "IN" },
  "areaServed": ["Pune","Mumbai","CSMIA T1","CSMIA T2","Navi Mumbai","Thane","Lonavala","Panvel"],
  "openingHoursSpecification": [{
    "@type": "OpeningHoursSpecification",
    "dayOfWeek": ["Monday","Tuesday","Wednesday","Thursday","Friday","Saturday","Sunday"],
    "opens": "00:00",
    "closes": "23:59"
  }],
  "aggregateRating": { "@type": "AggregateRating", "ratingValue": "4.8", "ratingCount": 7521 }
};

const breadcrumbSchema = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": [
    { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://www.meghanacabs.com/" },
    { "@type": "ListItem", "position": 2, "name": "Pune to Mumbai Cabs", "item": "https://www.meghanacabs.com/pune-to-mumbai-cabs" }
  ]
};

const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "What are the Pune to Mumbai cab fares?",
      "acceptedAnswer": { "@type": "Answer", "text": "Sedan fares start around ₹1999 for one-way. Final price depends on cab type, date, and pickup/drop areas." }
    },
    {
      "@type": "Question",
      "name": "Do you serve Mumbai Airport (T1/T2)?",
      "acceptedAnswer": { "@type": "Answer", "text": "Yes, we provide direct drops and pickups at CSMIA Terminal 1 and Terminal 2 with flight monitoring." }
    },
    {
      "@type": "Question",
      "name": "Can I book one-way as well as round trip?",
      "acceptedAnswer": { "@type": "Answer", "text": "Yes, both one-way and round trip options are available with flexible return scheduling." }
    },
    {
      "@type": "Question",
      "name": "Which cab types are available?",
      "acceptedAnswer": { "@type": "Answer", "text": "Clean AC Sedan, SUV, and premium cars driven by verified professionals. Choose as per passengers and luggage." }
    }
  ]
};






    return (
        <div>
<Helmet>
  <title>Pune to Mumbai Cabs | One Way & Round Trip Taxi | Airport T1/T2 | Meghana Cabs</title>
  <meta
    name="description"
    content="Book Pune to Mumbai cabs for one-way or round trip. Fixed-fare options, AC Sedan & SUV, Mumbai Airport T1/T2 pickup & drop, 24x7 support, verified drivers."
  />
  <link rel="canonical" href="https://www.meghanacabs.com/pune-to-mumbai-cabs" />
  <meta name="robots" content="index,follow,max-snippet:-1,max-image-preview:large,max-video-preview:-1" />

  {/* Optional meta keywords */}
  <meta
    name="keywords"
    content="Pune to Mumbai Cabs, Pune to Mumbai Taxi, One Way Cab Pune to Mumbai, Round Trip Cab Pune Mumbai, Pune to Mumbai Airport Cab, Pune to T2 Taxi, Sedan SUV Cab Pune Mumbai"
  />

  {/* Open Graph */}
  <meta property="og:type" content="website" />
  <meta property="og:title" content="Pune to Mumbai Cabs | Meghana Cabs" />
  <meta
    property="og:description"
    content="Reliable Pune–Mumbai taxi: one-way & round trip, airport T1/T2, fixed fares, AC Sedan & SUV."
  />
  <meta property="og:url" content="https://www.meghanacabs.com/pune-to-mumbai-cabs" />
  <meta property="og:image" content="https://www.meghanacabs.com/assets/images/pune-to-mumbai-cabs.jpg" />

  {/* Twitter */}
  <meta name="twitter:card" content="summary_large_image" />
  <meta name="twitter:title" content="Pune to Mumbai Cabs | Meghana Cabs" />
  <meta
    name="twitter:description"
    content="Book Pune–Mumbai cabs: one-way & round trip, airport T1/T2 service, fixed fares, AC Sedan & SUV."
  />
  <meta name="twitter:image" content="https://www.meghanacabs.com/assets/images/pune-to-mumbai-cabs.jpg" />

  {/* JSON-LD */}
  <script type="application/ld+json">{JSON.stringify(cabServiceSchema)}</script>
  <script type="application/ld+json">{JSON.stringify(localBusinessSchema)}</script>
  <script type="application/ld+json">{JSON.stringify(breadcrumbSchema)}</script>
  <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
</Helmet>




            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/24.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                             <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetomumbaicabs;